
var textosemana = new Array(7);
let firstLoad = true;
let retraso = 0;

function actualizarContador() {
  var contador = document.getElementById("product-countdown");
  let container = document.qier;
  let pais = obtenerPais();
  let idioma = Shopify.locale.toUpperCase();
  // var ahora = new Date('2024-12-24');
  var ahora = new Date();
  let currentDay = ahora.getDay();
  let fechaEntrega = ahora;
  let festivoNacionales = obtenerFestivosNacionales(pais);
  let diasTransito = horasTransito(pais);
  let horaCorte = 16;
  let horaCalculaDiferencia = 15;
  if (
      ahora.getFullYear() === 2025 &&
      ahora.getMonth() === 11 &&
      ahora.getDate() === 5
  ) {
      horaCorte = 13;
      horaCalculaDiferencia = 12;
  }

  rellenarDiasSemana(idioma);
  // Si esta por encima de la ahora de corte, se  suma 1 dia.
  if (fechaEntrega.getHours() >= horaCorte) {
    fechaEntrega.setDate(fechaEntrega.getDate() + 1);
  } else if (fechaEntrega.getDay() == "6" || fechaEntrega.getDay() == "0") {
    //El siguiente dia es un fin de semana.
    fechaEntrega.setDate(fechaEntrega.getDate() + 1);
  }

  // Comprobar los dias festivos.
  while (eslaboral(fechaEntrega, festivoNacionales) == 0) {
    fechaEntrega.setDate(fechaEntrega.getDate() + 1);
  }

  // Se suma los dias de transito.
  fechaEntrega.setDate(fechaEntrega.getDate() + diasTransito);

  // Se vuelve a comprobar si la fecha actual es laboral.
  while (eslaboral(fechaEntrega, festivoNacionales) == 0) {
    fechaEntrega.setDate(fechaEntrega.getDate() + 1);
  }

  let diferencia = fechaEntrega - ahora;

  let horasEntrega = Math.round(diferencia / (1000 * 60 * 60));

  var diaSemana = ahora.getDay();
  var horas = horaCalculaDiferencia - ahora.getHours();
  var minutos = 59 - ahora.getMinutes();
  var segundos = 59 - ahora.getSeconds();

  if (
    horasEntrega <= 24 &&
    fechaEntrega.getHours() < horaCorte &&
    currentDay > 0 &&
    currentDay < 6
  ) {
    switch (idioma) {
      case "ES":
        contador.innerHTML = ` Haz un pedido antes de ${horas}h. ${minutos}m.  ${segundos}s. y te llegará el <b>${
          textosemana[fechaEntrega.getDay()]
        } día ${fechaEntrega.getDate()} </b>`;
        break;
      case "FR":
        contador.innerHTML = `Passer une commande avant ${horas}h. ${minutos}m.  ${segundos}s. et elle sera expédiée <b>${
          textosemana[fechaEntrega.getDay()]
        } jour ${fechaEntrega.getDate()} </b>`;
        break;
      case "DE":
        contador.innerHTML = `Bestellen Sie vor ${horas}h. ${minutos}m. ${segundos}s. und es wird am <b>${
          textosemana[fechaEntrega.getDay()]
        } den  ${fechaEntrega.getDate()}</b>`;
        break;
      case "IT":
        contador.innerHTML = `Effettua un ordine prima delle ${horas}h. ${minutos}m. ${segundos}s. e verrà consegnato <b>${
          textosemana[fechaEntrega.getDay()]
        } giorno ${fechaEntrega.getDate()} </b>`;
        break;
      case "NL":
        contador.innerHTML = `Plaats een bestelling voor ${horas}h. ${minutos}m. ${segundos}s. en het wordt geleverd op <b>${
          textosemana[fechaEntrega.getDay()]
        } ${fechaEntrega.getDate()}</b>`;
        break;
      case "PT-PT":
        contador.innerHTML = `Faça um pedido antes das ${horas}h. ${minutos}m. ${segundos}s. e será entregue na <b>${
          textosemana[fechaEntrega.getDay()]
        } dia ${fechaEntrega.getDate()} </b>`;
        break;
      case "EN":
        contador.innerHTML = `Place an order before ${horas}h. ${minutos}m. ${segundos}s. and it will be delivered on <b>${
          textosemana[fechaEntrega.getDay()]
        }, the ${fechaEntrega.getDate()} </b>`;
        break;
      case "DA":
        contador.innerHTML = `Afgiv en ordre inden ${horas}t. ${minutos}m. ${segundos}s. og den vil blive leveret på <b>${
          textosemana[fechaEntrega.getDay()]
        }, den ${fechaEntrega.getDate()} </b>`;
        break;
      default:
        document.getElementsByClassName("container-product-countdown")[0].style.display = "none";
      // console.log("No se ha detectado el idioma!");
    }
  } else {
    switch (idioma) {
      case "ES":
        contador.innerHTML = `Haz un pedido y te llegará el <b>${
          textosemana[fechaEntrega.getDay()]
        } día ${fechaEntrega.getDate()} </b>`;
        break;
      case "FR":
        contador.innerHTML = `Passez une commande et vous recevrez le <b>${
          textosemana[fechaEntrega.getDay()]
        } jour ${fechaEntrega.getDate()} </b>`;
        break;
      case "DE":
        contador.innerHTML = `Geben Sie Ihre Bestellung auf und Sie erhalten sie am <b>${
          textosemana[fechaEntrega.getDay()]
        } den  ${fechaEntrega.getDate()}</b>`;
        break;
      case "IT":
        contador.innerHTML = `Effettua un ordine e ti arriverà il <b>${
          textosemana[fechaEntrega.getDay()]
        } giorno ${fechaEntrega.getDate()} </b>`;
        break;
      case "NL":
        contador.innerHTML = `Plaats een bestelling en het wordt geleverd op <b>${
          textosemana[fechaEntrega.getDay()]
        } ${fechaEntrega.getDate()}</b>`;
        break;
      case "PT-PT":
        contador.innerHTML = `Faça um pedido e será entregue na <b>${
          textosemana[fechaEntrega.getDay()]
        } dia ${fechaEntrega.getDate()} </b>`;
        break;
      case "EN":
        contador.innerHTML = `Place an order and it will be delivered on <b>${
          textosemana[fechaEntrega.getDay()]
        }, the ${fechaEntrega.getDate()} </b>`;
        break;
      case "DA":
        contador.innerHTML = `Afgiv en ordre, og den vil blive leveret på <b>${
          textosemana[fechaEntrega.getDay()]
        } den ${fechaEntrega.getDate()} </b>`;
        break;
      default:
        document.getElementsByClassName("countdown_container")[0].style.display = "none";
      // console.log("No se ha detectado el idioma!");
    }
  }
}

// Actualizar el contador cada segundo
document.addEventListener("DOMContentLoaded", (event) => {

  actualizarContador();
  setInterval(actualizarContador, 1000);
});

function obtenerPais() {
  // Obtener la URL actual
  // var url = window.location.href;
  // var paisPredeterminado = "ES";
  // var regex = /\/\/[\w.-]+\/(\w\w)\//;
  // var coincidencia = url.match(regex);
  // if (coincidencia && coincidencia[1].length === 2) {
  //   return coincidencia[1].toUpperCase();
  // } else {
  //   return paisPredeterminado;
  // }

  return Shopify.country.toUpperCase();
}

function obtenerFestivosNacionales(pais) {
  var festivos = [];
  var fecha = new Date();

  switch (pais) {
    case "ES":
      festivos.push(new Date(fecha.getFullYear()+1, 0, 1)); 
      festivos.push(new Date(fecha.getFullYear(), 0, 1));
      festivos.push(new Date(fecha.getFullYear()+1, 0, 6));
      festivos.push(new Date(fecha.getFullYear(), 0, 6));
      festivos.push(new Date(fecha.getFullYear(), 3, 3));
      festivos.push(new Date(fecha.getFullYear(), 3, 6));
      festivos.push(new Date(fecha.getFullYear(), 4, 1));
      festivos.push(new Date(fecha.getFullYear(), 4, 11));
      festivos.push(new Date(fecha.getFullYear(), 5, 24));
      festivos.push(new Date(fecha.getFullYear(), 7, 15));
      festivos.push(new Date(fecha.getFullYear(), 8, 11));
      festivos.push(new Date(fecha.getFullYear(), 8, 29));
      festivos.push(new Date(fecha.getFullYear(), 9, 12));
      festivos.push(new Date(fecha.getFullYear(), 10, 1));
      festivos.push(new Date(fecha.getFullYear(), 11, 6));
      festivos.push(new Date(fecha.getFullYear(), 11, 8));
      festivos.push(new Date(fecha.getFullYear(), 11, 25));
      festivos.push(new Date(fecha.getFullYear(), 11, 26));
      break;
    case "FR":
      festivos.push(new Date(fecha.getFullYear()+1, 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 3, 21));
      festivos.push(new Date(fecha.getFullYear(), 4, 1));
      festivos.push(new Date(fecha.getFullYear(), 4, 8));
      festivos.push(new Date(fecha.getFullYear(), 4, 29));
      festivos.push(new Date(fecha.getFullYear(), 5, 9));
      festivos.push(new Date(fecha.getFullYear(), 6, 14));
      festivos.push(new Date(fecha.getFullYear(), 7, 15));
      festivos.push(new Date(fecha.getFullYear(), 10, 1));
      festivos.push(new Date(fecha.getFullYear(), 10, 11));
      festivos.push(new Date(fecha.getFullYear(), 11, 25));
      break;
    case "DE":
      festivos.push(new Date(fecha.getFullYear()+1, 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 3, 18));
      festivos.push(new Date(fecha.getFullYear(), 3, 21));
      festivos.push(new Date(fecha.getFullYear(), 4, 1));
      festivos.push(new Date(fecha.getFullYear(), 4, 29));
      festivos.push(new Date(fecha.getFullYear(), 5, 9));
      festivos.push(new Date(fecha.getFullYear(), 9, 3));
      festivos.push(new Date(fecha.getFullYear(), 11, 25));
      festivos.push(new Date(fecha.getFullYear(), 11, 26));
      break;
    case "IT":
      festivos.push(new Date(fecha.getFullYear()+1, 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 0, 6));
      festivos.push(new Date(fecha.getFullYear(), 3, 20));
      festivos.push(new Date(fecha.getFullYear(), 3, 21));
      festivos.push(new Date(fecha.getFullYear(), 3, 25));
      festivos.push(new Date(fecha.getFullYear(), 4, 1));
      festivos.push(new Date(fecha.getFullYear(), 5, 2));
      festivos.push(new Date(fecha.getFullYear(), 7, 15));
      festivos.push(new Date(fecha.getFullYear(), 10, 1));
      festivos.push(new Date(fecha.getFullYear(), 11, 8));
      festivos.push(new Date(fecha.getFullYear(), 11, 25));
      festivos.push(new Date(fecha.getFullYear(), 11, 26));
      break;
    case "NL":
      festivos.push(new Date(fecha.getFullYear()+1, 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 3, 18));
      festivos.push(new Date(fecha.getFullYear(), 3, 20));
      festivos.push(new Date(fecha.getFullYear(), 3, 21));
      festivos.push(new Date(fecha.getFullYear(), 3, 26));
      festivos.push(new Date(fecha.getFullYear(), 4, 5));
      festivos.push(new Date(fecha.getFullYear(), 4, 29));
      festivos.push(new Date(fecha.getFullYear(), 5, 8));
      festivos.push(new Date(fecha.getFullYear(), 5, 9));
      festivos.push(new Date(fecha.getFullYear(), 11, 25));
      festivos.push(new Date(fecha.getFullYear(), 11, 26));
      break;
    case "PT-PT":
      festivos.push(new Date(fecha.getFullYear()+1, 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 0, 1));
      festivos.push(new Date(fecha.getFullYear(), 3, 18));
      festivos.push(new Date(fecha.getFullYear(), 3, 20));
      festivos.push(new Date(fecha.getFullYear(), 3, 25));
      festivos.push(new Date(fecha.getFullYear(), 4, 1));
      festivos.push(new Date(fecha.getFullYear(), 5, 10));
      festivos.push(new Date(fecha.getFullYear(), 5, 19));
      festivos.push(new Date(fecha.getFullYear(), 7, 15));
      festivos.push(new Date(fecha.getFullYear(), 8, 5));
      festivos.push(new Date(fecha.getFullYear(), 9, 5));
      festivos.push(new Date(fecha.getFullYear(), 10, 1));
      festivos.push(new Date(fecha.getFullYear(), 11, 8));
      festivos.push(new Date(fecha.getFullYear(), 11, 25));
      break;
  }

  return festivos;
}

function eslaboral(fecha, festivos) {
  var esfestivo = 0;
  var i;
  let diaSemana = fecha.getDay();
  let dia = fecha.getDate();
  let mes = fecha.getMonth();
  let year = fecha.getFullYear();
  // console.log(dia,mes,year);

  for (i = 0; i < festivos.length; i++) {
    let festivo = festivos[i];
    let festivoDia = festivo.getDate();
    let festivoMes = festivo.getMonth();
    let festivoYear = festivo.getFullYear();

    if (dia == festivoDia && mes == festivoMes && year == festivoYear) {
      // console.log(festivoDia, festivoMes, festivoYear);

      return 0;
    }

    difference = fecha - festivos[i];
    horas = Math.round(difference / (1000 * 60 * 60));
    if (horas > 0 && horas < 24) {
      return 0;
    }
  }

  if (diaSemana == "6" || diaSemana == "0") {
    return 0;
  }

  return 1;
}
function horasTransito(pais) {
  let transito = 0;
  switch (pais) {
    case "ES":
      transito = 1;
      break;
    case "FR":
    case "MC":
    case "LU":
    case "AU":
    case "IE":
      transito = 3;
      break;
    case "DE":
      transito = 5;
      break;
    case "PT-PT":
      transito = 2;
      break;
    case "IT":
      transito = 3;
      break;
    case "NL":
      transito = 3;
      break;
    case "EN":
      transito = 2;
      break;
    case "DA":
      transito = 5;
      break;
  }

  // if(pais != 'ES' && pais != 'PT')
  // {
  //   transito += 3;
  // }else{  
  //   transito += 2;
  // }

  if (firstLoad) {
    let marca = document.getElementById("marca").value;
    let temporada = document.getElementById("temporada").value;

    if (temporada.startsWith("c")) {
      switch (marca) {
        case "zian":
        case "duuo":
        case "toni pons":
        case "alpe":
        case "alma en pena":
          retraso = 2;
          break;
        case "munich":
          retraso = 3;
          break;
        case "camper":
          retraso = 8;
          break;
        default:
          retraso = 0;
      }
    }

    if (temporada.startsWith("d")) {
      switch (marca) {
        case "porronet":
          retraso = 2;
          break;
        case "basic comfort":
        case "refresh":
        case "xti":
        case "carmela":
        case "mustang":
        case "sixty seven":
        case "maria mare":
        case "hispanitas":
        case "wonders":
          retraso = 2;
          break;
        case "popa":
          retraso = 3;
          break;
      }
    }

    if (temporada.startsWith("6")) {
      switch (marca) {
        case "pikolinos":
        case "martinelli":
          retraso = 3;
          break;
      }
    }

    firstLoad = false;
    document.getElementById("marca").remove();
    document.getElementById("temporada").remove();
  }

  transito += retraso;
  return transito;
}

function rellenarDiasSemana(pais) {
  switch (pais) {
    case "ES":
      textosemana[0] = "Domingo";
      textosemana[1] = "Lunes";
      textosemana[2] = "Martes";
      textosemana[3] = "Miércoles";
      textosemana[4] = "Jueves";
      textosemana[5] = "Viernes";
      textosemana[6] = "Sábado";
      break;
    case "FR":
      textosemana[0] = "Dimanche";
      textosemana[1] = "Lundi";
      textosemana[2] = "Mardi";
      textosemana[3] = "Mercredi";
      textosemana[4] = "Jeudi";
      textosemana[5] = "Vendredi";
      textosemana[6] = "Samedi";
      break;
    case "DE":
      textosemana[0] = "Sonntag";
      textosemana[1] = "Montag";
      textosemana[2] = "Dienstag";
      textosemana[3] = "Mittwoch";
      textosemana[4] = "Donnerstag";
      textosemana[5] = "Freitag";
      textosemana[6] = "Samstag";
      break;
    case "PT-PT":
      textosemana[0] = "Domingo";
      textosemana[1] = "Segunda-feira";
      textosemana[2] = "Terça-feira";
      textosemana[3] = "Quarta-feira";
      textosemana[4] = "Quinta-feira";
      textosemana[5] = "Sexta-feira";
      textosemana[6] = "Sábado";
      break;
    case "IT":
      textosemana[0] = "Domenica";
      textosemana[1] = "Lunedì";
      textosemana[2] = "Martedì";
      textosemana[3] = "Mercoledì";
      textosemana[4] = "Giovedì";
      textosemana[5] = "Venerdì";
      textosemana[6] = "Sabato";
      break;
    case "NL":
      textosemana[0] = "Zondag";
      textosemana[1] = "Maandag";
      textosemana[2] = "Dinsdag";
      textosemana[3] = "Woensdag";
      textosemana[4] = "Donderdag";
      textosemana[5] = "Vrijdag";
      textosemana[6] = "Zaterdag";
      break;
    case "EN":
      textosemana[0] = "Sunday";
      textosemana[1] = "Monday";
      textosemana[2] = "Tuesday";
      textosemana[3] = "Wednesday";
      textosemana[4] = "Thursday";
      textosemana[5] = "Friday";
      textosemana[6] = "Saturday";
      break;
    case "DA":
      textosemana[0] = "søndag";
      textosemana[1] = "mandag";
      textosemana[2] = "tirsdag";
      textosemana[3] = "onsdag";
      textosemana[4] = "torsdag";
      textosemana[5] = "fredag";
      textosemana[6] = "lørdag";
      break;

    default:
      break;
  }
}
